import { render, staticRenderFns } from "./selfVehicleList.vue?vue&type=template&id=b352fde4"
import script from "./selfVehicleList.vue?vue&type=script&lang=js"
export * from "./selfVehicleList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports